{
  "tile": 32,
  "tileh": 32,
  "map": {
    "backgroundPlanet": [10, 0, 8, 8],
    "dinoHead": [0, 0, 3, 2],
    "dinoBody": [3, 0, 5, 4],
    "dinoArm": [1, 4, 2, 2],
    "dinoNeck": [3, 4, 2, 2],
    "dinoJaw": [0, 2, 3, 2],
    "dinoTail": [2, 6, 4, 2],
    "dinoUpperLeg": [5, 4, 2, 2],
    "dinoLowerLeg": [1, 6, 1, 2],
    "dinoFeet": [0, 6, 1, 1],
    "dinoToes": [0, 5, 1, 1],
    "dinoTongue": [0, 4, 1, 1],
    "dinoBackFeet": [0, 7, 1, 1],
    "dinoBackUpperLeg": [6, 6, 2, 2],
    "dinoBackLowerLeg": [7, 4, 1, 2],
    "dinoBackToes": [8, 4, 1, 1],
    "dinoTentacles": [8, 0, 2, 1]
  }
}
